import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

export default class Amplitude {
  static configure() {
    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: 0.3,
    });
    amplitude.add(sessionReplayTracking);
    amplitude.init(import.meta.env.VITE_AMPLITUDE_API_KEY, {
      autocapture: true,
      serverZone: 'EU',
    });
  }

  static initUser(identifiers: { id?: string; email?: string }) {
    const identifyEvent = new amplitude.Identify();

    if (identifiers.id) {
      amplitude.setUserId(identifiers.id);
    }

    if (identifiers.email) {
      identifyEvent.setOnce('email', identifiers.email);
    }

    amplitude.identify(identifyEvent);
  }
}
